import {Dropdown, Icon, Menu} from "antd";
import React from "react";
import './HeaderDropdown.css';
import DynamicIcon from "../../components/DynamicIcon";
import UserOutlined from "@ant-design/icons/es/icons/UserOutlined";

const menuHeaderDropdown = menuItems => {
    const onClick = ({key}) => {
        const item = menuItems.find(i => i.key === key);
        if (item && item.callback)
            item.callback();
    };
    return (
        <Menu onClick={onClick} selectedKeys={[]}>
            {menuItems.map(item => {
                const {key, icon, value} = item;
                return (
                    <Menu.Item key={key}>
                        <DynamicIcon type={icon} />
                        <span>{value}</span>
                    </Menu.Item>);
            })}
        </Menu>
    );
};

const HeaderDropdown = props => {
    const {user, userData, menuItems, darkMode} = props;
    if (!user || !userData)
        return null;
    const {name, lastname} = userData;
    return (
        <Dropdown overlayClassName={darkMode && 'dark-mode'}
            overlay={menuHeaderDropdown(menuItems)}
            {...props}
        >
            <div className='header-container'>
                <span>{name} {lastname} <UserOutlined />  </span>
            </div>
        </Dropdown>
    )
};

export default HeaderDropdown;
